module.exports = __webpack_public_path__ + "img/brazil.67271d03.svg";